import React, { useContext, useEffect, useState} from 'react';
import {IProps, IState} from './types';
import { useSelector } from 'react-redux';
import selectors from '@state/selectors';
import Button from '@components/Button';
import * as S from './styles';
import C from '@assets/themes/colors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { UserAccessContext } from '@utils/DOIgnition/UserAccessContex';

const uuid = require('react-uuid');



const DeleteUserProfile:React.FC<IProps> = (props) => {
  const authContext = useContext(AuthContext);
  const {deleteUserAccess, clearDeletedUserAccess } = useContext(UserAccessContext)  
  const deletedUserAccess = useSelector(selectors.userAccess.getDeletedUserAccess);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const userItem = props.item  



  const handleDelete = () => {    
    if(userItem) {
      setIsDeleting(true)
      deleteUserAccess(userItem.id)      
    }
  }  

  useEffect(()=>{    
    if (deletedUserAccess)
    {
      clearDeletedUserAccess();
      setIsDeleting(false);      
      if (props && props.onActions)
        props.onActions(props.item, "DELETEUSER")             
      
    }

  },[deletedUserAccess])




  const getDeleteMessage=()=>{        
      return (
        <>
        <S.SummaryMessage>
        Are you sure you want to delete this user?
        </S.SummaryMessage>
        <S.SummaryMessage style={{marginTop:'40px', marginBottom:'80px'}}> 
        This action cannot be undone.                   
        </S.SummaryMessage>
        </>
      )


  }

  
  return (
    <S.Root style={{
      display: props.open ? 'flex' : 'none',
    }} >
      <S.BoxContainer>
        <S.TitleContainer>
          <S.LeftSide>
            <S.Title>
            Delete User
            </S.Title>
          </S.LeftSide>
        </S.TitleContainer>
        <S.Content>
            {getDeleteMessage()}
        </S.Content>
        <S.ActionsContainer>
          <S.Action>
            <Button
              label="CANCEL"
              style={{
                width: '112px',
                marginRight: 12, 
                backgroundColor: "transparent", 
                border: `1px solid ${C.BLUE}`, 
                hoverBackgroundColor: `${C.BLUE}22`,
              }}
              labelStyle={{color: C.BLUE}}
              onClick={() => {
                if (props && props.onActions)
                  props.onActions(props.item, "CANCELDELETEUSER")             
                }
              }
              disabled={isDeleting}
            />
          </S.Action>
          <S.Action>
            <Button
              label={isDeleting ? "DELETING..." : "YES, DELETE"}
              style={{
                width: '112px',
                backgroundColor: C.BLUE, 
                flexGrow: 0, 
                hoverBackgroundColor: `${C.BLUE}AA`,
              }} 
              onClick={()=>handleDelete()}
              disabled={isDeleting}
            />
          </S.Action>
        </S.ActionsContainer>
      </S.BoxContainer>
    </S.Root>
  );
}

export default DeleteUserProfile;